import {  About, Components, Contact, Education, Experiences, Products, Projects } from '..';

export const links = [
    {
        label: 'About',
        id: 'about',
        component: About,
        show: true,
    },
    {
        label: 'Experiences',
        id: 'experiences',
        component: Experiences,
        show: true,
    },
    {
        label: 'Projects',
        id: 'projects',
        component: Projects,
        show: true,
    },
    {
        label: 'Products',
        id: 'products',
        component: Products,
        show: true,
    },
    {
        label: 'Components',
        id: 'components',
        component: Components,
        show: true,
    },
    {
        label: 'Education',
        id: 'education',
        component: Education,
        show: true,
    },
    {
        label: 'Contact',
        id: 'contact',
        component: Contact,
        show: true,
    }
]